import SlimSelect from "slim-select";

// CRO-120: drives the inline "buy online" form rendered in the colour-detail
// hero (Views/Partials/Hero/ColourDetailHero.cshtml). Selecting a paint type
// repopulates the product dropdown, which repopulates the finish dropdown and
// points the buy button at the correct B&Q / TradePoint product page.
const DEFAULT_PRODUCT_NAME = "Premium Walls & Ceilings";

export default function ColourDetailBuy() {
    document.querySelectorAll("[data-buy-form]").forEach(setupBuyForm);
}

function setupBuyForm(form) {
    const dataEl = form.querySelector("[data-buy-data]");
    const productSelect = form.querySelector("[data-buy-product]");
    const finishSelect = form.querySelector("[data-buy-finish]");
    const buyBtn = form.querySelector("[data-buy-button]");

    if (!dataEl || !productSelect || !finishSelect || !buyBtn) return;

    let categories;
    try {
        categories = JSON.parse(dataEl.textContent);
    } catch (e) {
        return;
    }
    if (!Array.isArray(categories) || !categories.length) return;

    // SlimSelect copies the <select>'s own classes onto both the control
    // (.ss-main) and the body-appended dropdown (.ss-content), so the
    // colour-detail-buy__select class is the shared styling hook for both.
    const productSS = new SlimSelect({ select: productSelect, settings: { showSearch: false } });
    const finishSS = new SlimSelect({ select: finishSelect, settings: { showSearch: false } });

    const thumb = (image, size) =>
        `${image}?width=${size}&height=${size}&rmode=boxpad`;

    const buildProductData = (products) =>
        products.map((p) => ({
            text: p.name,
            value: p.name,
            html: p.image
                ? `<img class="colour-detail-buy__product-img" width="32" height="32" src="${thumb(p.image, 32)}" srcset="${thumb(p.image, 64)} 2x" alt="" loading="lazy"><span class="colour-detail-buy__product-name">${p.name}</span>`
                : `<span class="colour-detail-buy__product-name">${p.name}</span>`,
        }));

    const buildFinishData = (product) =>
        product.bq.map((b) => ({ text: b.type, value: b.type }));

    const getCheckedCategory = () => {
        const checked = form.querySelector("[data-buy-cat]:checked");
        return checked ? categories[parseInt(checked.value, 10)] : categories[0];
    };

    const getCurrentProduct = (category) =>
        category.products.find((p) => p.name === productSelect.value) || category.products[0];

    const updateBuyButton = (product, finishType) => {
        const entry = product.bq.find((b) => b.type === finishType) || product.bq[0];
        if (!entry) return;
        // Ready Mix entries carry a complete B&Q URL (no shared base / colour-ref segment),
        // so use it verbatim; standard products keep the assembled base/colour-ref/EAN path.
        buyBtn.href = entry.fullUrl
            ? entry.fullUrl
            : `${entry.link}/${product.colourRef}/${entry.productUrl}`;

        const retail = buyBtn.querySelector(".retail-link");
        const trade = buyBtn.querySelector(".trade-link");
        if (retail) retail.style.display = product.isTrade ? "none" : "";
        if (trade) trade.style.display = product.isTrade ? "" : "none";
    };

    const syncFinishAndBuy = (product) => {
        finishSS.setData(buildFinishData(product));
        const finishType = product.bq[0] ? product.bq[0].type : "";
        updateBuyButton(product, finishType);
    };

    const syncCategory = (category, preferredName) => {
        if (!category || !category.products.length) return;
        productSS.setData(buildProductData(category.products));

        let product = category.products[0];
        if (preferredName) {
            const found = category.products.find((p) => p.name === preferredName);
            if (found) {
                product = found;
                productSS.setSelected(preferredName);
            }
        }
        syncFinishAndBuy(product);
    };

    // Initial render: default to the standard product where it exists.
    syncCategory(getCheckedCategory(), DEFAULT_PRODUCT_NAME);

    form.querySelectorAll("[data-buy-cat]").forEach((radio) => {
        radio.addEventListener("change", () => {
            const checked = form.querySelector("[data-buy-cat]:checked");
            if (!checked) return;
            syncCategory(categories[parseInt(checked.value, 10)]);
        });
    });

    productSelect.addEventListener("change", () => {
        const product = getCurrentProduct(getCheckedCategory());
        if (product) syncFinishAndBuy(product);
    });

    finishSelect.addEventListener("change", () => {
        const product = getCurrentProduct(getCheckedCategory());
        if (product) updateBuyButton(product, finishSelect.value);
    });
}
